function getWinsWinners(lastRacePlayers) {
  let maxWins = 0;
  let winners = [];

  for (const [playerId, playerStats] of Object.entries(lastRacePlayers)) {
    if (playerStats['firsts'] > maxWins) {
      maxWins = playerStats['firsts'];
      winners = [playerId];
    } else if (playerStats['firsts'] === maxWins) {
      winners.push(playerId);
    }
  }

  return winners;
}

function getScoreWinners(lastRacePlayers) {
  let maxScore = 0;
  let winners = [];

  for (const [playerId, playerStats] of Object.entries(lastRacePlayers)) {
    if (playerStats['totalScore'] > maxScore) {
      maxScore = playerStats['totalScore'];
      winners = [playerId];
    } else if (playerStats['totalScore'] === maxScore) {
      winners.push(playerId);
    }
  }

  return winners;
}

function isTie(raceHistory, method="score") {

  let winners = [];
  let tie = false;

  if (!["score", "wins"].includes(method)) {
    throw Error("Invalid method provided. Must be either: 'score' or 'wins'.");
  }

  let lastRace = JSON.parse(JSON.stringify(raceHistory[raceHistory.length - 1]));
  if (method === "score") {
    winners = getScoreWinners(lastRace.racePlayers);
  } else if (method === "wins") {
    winners = getWinsWinners(lastRace.racePlayers);
  } else {
    throw Error("Invalid method provided. Must be either: 'score' or 'wins'.");
  }

  if (winners.length > 1) {
    tie = true;
  }

  return {"tie": tie, "winners": winners}
}

module.exports = {
  isTie,
  getWinsWinners,
  getScoreWinners,
};
